const resource = 'offers';

export default ($axios, isAdmin=false) => ({
	getOffers(params={}) {
		return $axios.get(`${isAdmin ? '/superAdmin': ''}/${resource}`, {params});
	},
	getOffer(id, params={}) {
		return $axios.get(`/${resource}/${id}`, {params});
	},
	// PUT
	updateOffer(offerData) {
		return $axios.put(`/${resource}/${offerData.id}`, offerData)
	},
})